import { StatesService } from 'src/app/core/store/states.service';

/**
 * 权限初始化
 */
export function permissionsInit(pss: StatesService) {
  return async () => {
    const authorized = await pss.authorizationInit();
    if (!authorized) {
      return;
    }

    pss.accountInfoInit();
    await pss.saasUserInfoInit();
  };
}
